const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "「机组成员」形象卡限时领取，来创建你的机组形象吧"
const desc = "现在就可以领取你的机组成员ID卡啦"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    externalLinkId: "140",
  },
}
